import { createSlice } from "@reduxjs/toolkit";
import {
  fetchBranchTransferPendingList,
  approveBranchTransaction,
  fetchBranches
} from "./branchTransferPendingThunk";

const branchTransferPendingSlice = createSlice({
  name: "branchTransferPending",
  initialState: {
    list: [],
    branches: [],
    branchLoading: false,
    filters: {
      fromBranchId: null,
    },
    loading: false,
    error: null,
  },
  reducers: {
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
    },
    resetList: (state) => {
      state.list = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchBranchTransferPendingList.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchBranchTransferPendingList.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload;
      })
      .addCase(fetchBranchTransferPendingList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(approveBranchTransaction.fulfilled, (state, action) => {
        // remove approved row from list
        state.list = state.list.filter(
          (row) => row.tran_id !== action.meta.arg.tranId
        );
      })
      .addCase(fetchBranches.pending, (state) => {
        state.branchLoading = true;
      })
      .addCase(fetchBranches.fulfilled, (state, action) => {
        state.branchLoading = false;
        state.branches = action.payload;
      })
      .addCase(fetchBranches.rejected, (state) => {
        state.branchLoading = false;
        state.branches = [];
      });
  },
});

export const { setFilters, resetList } = branchTransferPendingSlice.actions;
export default branchTransferPendingSlice.reducer;
